import PaymentCycleResource from "./paymentCycle.resource";

const paymentCycleModule = angular
  .module("app.resources.paymentCycle", [])
  .service("PaymentCycle", PaymentCycleResource);

export default paymentCycleModule;



// WEBPACK FOOTER //
// ./src/resources/paymentCycle/paymentCycle.module.js